import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'

import index from '@/components/index'
import lqLayer from '@/components/lqLayer/lqLayer'
import swLayer from '@/components/swLayer/swLayer'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/lqLayer',
      name: 'HelloWorld',
      component: index
    },
    {
      path: '/index',
      name: '首页',
      component: index,
      children: [
        {
          path: '/lqLayer',
          name: 'lqLayer',
          component: lqLayer,
          icon: 'el-icon-office-building'
        }, {
          path: '/swLayer',
          name: 'swLayer',
          component: swLayer,
          icon: 'el-icon-user'
        }
      ],
     
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js